var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_action_settings_24px",
    "data-name": "icon/action/settings_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M10.851,19h-3.7a.474.474,0,0,1-.463-.4l-.347-2.518a6.712,6.712,0,0,1-1.562-.926l-2.3.95a.494.494,0,0,1-.16.027.455.455,0,0,1-.407-.24L.055,12.6a.5.5,0,0,1,.116-.606l1.955-1.568A6.172,6.172,0,0,1,2.057,9.5a6.06,6.06,0,0,1,.081-.926L.182,7.007A.468.468,0,0,1,.067,6.4l1.851-3.29a.459.459,0,0,1,.4-.245.444.444,0,0,1,.165.032l2.3.95A6.934,6.934,0,0,1,6.35,2.921L6.7.4A.454.454,0,0,1,7.148,0h3.7a.467.467,0,0,1,.463.4l.347,2.518a6.745,6.745,0,0,1,1.562.926l2.3-.95a.494.494,0,0,1,.16-.027.455.455,0,0,1,.407.24L17.945,6.4a.5.5,0,0,1-.116.606L15.873,8.574a6.069,6.069,0,0,1,.069.926,7.949,7.949,0,0,1-.058.926l1.933,1.568a.468.468,0,0,1,.115.606l-1.851,3.289a.459.459,0,0,1-.4.245.444.444,0,0,1-.165-.032l-2.3-.95a6.869,6.869,0,0,1-1.562.926L11.3,18.6A.443.443,0,0,1,10.851,19ZM9,5.938a3.564,3.564,0,0,0,0,7.125A3.564,3.564,0,0,0,9,5.938Z",
    transform: "translate(3 2.5)",
    fill: "#555a60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c97f7615320c33e4ee0504dd66cc5266.svg";
export { ForwardRef as ReactComponent };